import React from "react";
import { useState } from "react";
import './TicketHistory.css'

const TicketHistory = ({ histories, notes }) => {
    const [activeInfoTab, setActiveInfoTab] = useState('history');
  
    const renderTabContent = () => {
      switch (activeInfoTab) {
        case 'history':
          return (
            <div className="content-section history">
              {histories?.slice(0, 1).map((item, index) => (
                <div key={index} className="history-item">
                  <p>{item.updateReason}</p>
                  <small>{item.updatedAt}</small>
                </div>
              ))}
              {histories?.length > 1 && (
                <button className="view-more">View More History</button>
              )}
            </div>
          );
        case 'notes':
          return (
            <div className="content-section notes">
              {notes?.slice(0, 1).map((note, index) => (
                <div key={index} className="note-item">
                  <p>{note.body}</p>
                  <small>
                    By {note.agent.username} ID: {note.agent.id}
                  </small>
                </div>
              ))}
              {notes?.length > 1 && (
                <button className="view-more">View More Notes</button>
              )}
            </div>
          );
        default:
          return null;
      }
    };
  
    return (
      <div className="ticket-additional-info">
        <div className="tab-navigation">
          <button 
            className={`tab-button ${activeInfoTab === 'history' ? 'active' : ''}`}
            onClick={() => setActiveInfoTab('history')}
          >
            Ticket History
          </button>
          <button 
            className={`tab-button ${activeInfoTab === 'notes' ? 'active' : ''}`}
            onClick={() => setActiveInfoTab('notes')}
          >
            Ticket Notes
          </button>
        </div>
        
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    );
  };

  export default TicketHistory